import { useEffect } from "react";
import { BRAND_FONTS_URL } from "./brand";

const FONT_LINK_ID = "devssoft-crm-fonts";
const BODY_CLASS = "devssoft-crm";

/** Carga las fuentes de marca y activa la tipografía del CRM (también en diálogos y menús). */
export default function useBrandScope() {
  useEffect(() => {
    if (!document.getElementById(FONT_LINK_ID)) {
      const link = document.createElement("link");
      link.id = FONT_LINK_ID;
      link.rel = "stylesheet";
      link.href = BRAND_FONTS_URL;
      document.head.appendChild(link);
    }
    document.body.classList.add(BODY_CLASS);
    return () => document.body.classList.remove(BODY_CLASS);
  }, []);
}
